import { initialState } from "./State";
import { GlobalSearchConstants } from "constants/Actions";
import { DataFunctions } from "./Functions";
import {
  CaseSearchResult,
  CaseSearchResultModel,
  CreditorSearchResult,
  CreditorSearchResultModel,
  DebtorSearchResult,
  DebtorSearchResultModel,
  InvoiceSearchResult,
  InvoiceSearchResultModel,
  MainSearchResults,
  SearchHistoryResultModel,
} from "./Types";
const { getInvoicesAndCasesArranged, getCreditorArranged, getDebtorArranged } =
  DataFunctions;

const {
  GET_ALL_GLOBAL_SEARCH_DATA,
  GET_ALL_GLOBAL_SEARCH_DATA_SUCCESS,
  GET_ALL_GLOBAL_SEARCH_DATA_FAIL,

  GET_INVOICE_REF_GLOBAL_SEARCH_DATA,
  GET_INVOICE_REF_GLOBAL_SEARCH_DATA_SUCCESS,
  GET_INVOICE_REF_GLOBAL_SEARCH_DATA_FAIL,

  GET_INVOICE_GLOBAL_SEARCH_DATA,
  GET_INVOICE_GLOBAL_SEARCH_DATA_SUCCESS,
  GET_INVOICE_GLOBAL_SEARCH_DATA_FAIL,

  GET_CASE_GLOBAL_SEARCH_DATA,
  GET_CASE_GLOBAL_SEARCH_DATA_SUCCESS,
  GET_CASE_GLOBAL_SEARCH_DATA_FAIL,

  GET_DEBTOR_GLOBAL_SEARCH_DATA,
  GET_DEBTOR_GLOBAL_SEARCH_DATA_SUCCESS,
  GET_DEBTOR_GLOBAL_SEARCH_DATA_FAIL,
  TOGGLE_GLOBAL_DEBTOR_AR,

  GET_CREDITOR_GLOBAL_SEARCH_DATA,
  GET_CREDITOR_GLOBAL_SEARCH_DATA_SUCCESS,
  GET_CREDITOR_GLOBAL_SEARCH_DATA_FAIL,
  TOGGLE_GLOBAL_CREDITOR_GROUP,

  GET_GLOBAL_SEARCH_HISTORY,
  GET_GLOBAL_SEARCH_HISTORY_SUCCESS,
  GET_GLOBAL_SEARCH_HISTORY_FAIL,

  GLOBAL_BROWSER_BACK_NAVIGATION,
  UPDATE_VIEWED_GLOBAL_LIST,

  GET_ARCHIVE_GLOBAL_SEARCH_DATA,
  GET_ARCHIVE_GLOBAL_SEARCH_DATA_SUCCESS,
  GET_ARCHIVE_GLOBAL_SEARCH_DATA_FAIL,

  GET_ARCHIVE_GLOBAL_CASE_DETAILS,
  GET_ARCHIVE_GLOBAL_CASE_DETAILS_SUCCESS,
  GET_ARCHIVE_GLOBAL_CASE_DETAILS_FAIL,

  GET_COMPANY_CONFIG,
  GET_COMPANY_CONFIG_SUCCESS,
  GET_COMPANY_CONFIG_FAIL,
} = GlobalSearchConstants;

export default (state: MainSearchResults = initialState, action: any) => {
  const getInvoiceObject = (
    data: InvoiceSearchResult[] | [],
    isLoading: boolean,
    isError: boolean
  ) => {
    return {
      invoice: <InvoiceSearchResultModel>{
        isLoading: isLoading,
        data: getInvoicesAndCasesArranged(data, "invoice"),
        isError: isError,
      },
    };
  };
  const getCaseObject = (
    data: CaseSearchResult[] | [],
    isLoading: boolean,
    isError: boolean
  ) => {
    return {
      case: <CaseSearchResultModel>{
        isLoading: isLoading,
        data: getInvoicesAndCasesArranged(data, "case"),
        isError: isError,
      },
    };
  };
  const getCreditorObject = (
    data: CreditorSearchResult[] | [],
    isLoading: boolean,
    isError: boolean
  ) => {
    return {
      creditor: <CreditorSearchResultModel>{
        isLoading: isLoading,
        data: getCreditorArranged(data),
        isError: isError,
      },
    };
  };
  const getDebtorObject = (
    data: DebtorSearchResult[] | [],
    isLoading: boolean,
    isError: boolean
  ) => {
    return {
      debtor: <DebtorSearchResultModel>{
        isLoading: isLoading,
        data: getDebtorArranged(data),
        isError: isError,
      },
    };
  };
  switch (action.type) {
    //#region All search
    case GET_ALL_GLOBAL_SEARCH_DATA:
      return Object.assign(
        {},
        state,
        getInvoiceObject([], true, false),
        getCaseObject([], true, false),
        getCreditorObject([], true, false),
        getDebtorObject([], true, false),
        { isDataArchived: false }
      );
    case GET_ALL_GLOBAL_SEARCH_DATA_SUCCESS:
      return Object.assign(
        {},
        state,
        getInvoiceObject(
          ((action.payload.data as any)[
            "invoiceses"
          ] as InvoiceSearchResult[]) ?? [],
          false,
          false
        ),
        getCaseObject(
          (action.payload.data as any)["cases"] as CaseSearchResult[],
          false,
          false
        ),
        getCreditorObject(
          (action.payload.data as any)["creditors"] as CreditorSearchResult[],
          false,
          false
        ),
        getDebtorObject(
          (action.payload.data as any)["debtors"] as DebtorSearchResult[],
          false,
          false
        ),
        { isDataArchived: false }
      );
    case GET_ALL_GLOBAL_SEARCH_DATA_FAIL:
      return Object.assign(
        {},
        state,
        getInvoiceObject([], false, true),
        getCaseObject([], false, true),
        getCreditorObject([], false, true),
        getDebtorObject([], false, true)
      );
    //#endregion

    //#region InvoiceRef search
    case GET_INVOICE_REF_GLOBAL_SEARCH_DATA:
      return Object.assign(
        {},
        state,
        getInvoiceObject([], true, false),
        getCaseObject([], true, false),
        { isDataArchived: false }
      );
    case GET_INVOICE_REF_GLOBAL_SEARCH_DATA_SUCCESS:
      return Object.assign(
        {},
        state,
        getInvoiceObject(
          ((action.payload.data as any)[
            "invoiceses"
          ] as InvoiceSearchResult[]) ?? [],
          false,
          false
        ),
        getCaseObject(
          (action.payload.data as any)["cases"] as CaseSearchResult[],
          false,
          false
        )
      );
    case GET_INVOICE_REF_GLOBAL_SEARCH_DATA_FAIL:
      return Object.assign(
        {},
        state,
        getInvoiceObject([], false, true),
        getCaseObject([], false, true)
      );
    //#endregion

    //#region for invoice search data
    case GET_INVOICE_GLOBAL_SEARCH_DATA:
      return Object.assign({}, state, getInvoiceObject([], true, false), {
        isDataArchived: false,
      });
    case GET_INVOICE_GLOBAL_SEARCH_DATA_SUCCESS:
      console.log("invoice data in reducer", action.payload.data);
      return Object.assign(
        {},
        state,
        getInvoiceObject(
          (action.payload.data as InvoiceSearchResult[]) ?? [],
          false,
          false
        )
      );
    case GET_INVOICE_GLOBAL_SEARCH_DATA_FAIL:
      return Object.assign({}, state, getInvoiceObject([], false, true));
    //#endregion

    //#region for case search data
    case GET_CASE_GLOBAL_SEARCH_DATA:
      return Object.assign({}, state, getCaseObject([], true, false), {
        isDataArchived: false,
      });

    case GET_CASE_GLOBAL_SEARCH_DATA_SUCCESS:
      return Object.assign(
        {},
        state,
        getCaseObject(
          (action.payload.data as CaseSearchResult[]) ?? [],
          false,
          false
        )
      );

    case GET_CASE_GLOBAL_SEARCH_DATA_FAIL:
      return Object.assign(
        {},
        state,
        getCaseObject(
          (action.payload.data as CaseSearchResult[]) ?? [],
          false,
          true
        )
      );
    //#endregion

    //#region for creditor search data
    case GET_CREDITOR_GLOBAL_SEARCH_DATA:
      return Object.assign({}, state, getCreditorObject([], true, false), {
        isDataArchived: false,
      });
    case GET_CREDITOR_GLOBAL_SEARCH_DATA_SUCCESS:
      return Object.assign(
        {},
        state,
        getCreditorObject(
          (action.payload.data as CreditorSearchResult[]) ?? [],
          false,
          false
        )
      );
    case GET_CREDITOR_GLOBAL_SEARCH_DATA_FAIL:
      return Object.assign({}, state, getCreditorObject([], false, true));
    case TOGGLE_GLOBAL_CREDITOR_GROUP:
      return Object.assign({}, state, {
        creditor: <CreditorSearchResultModel>{
          isLoading: false,
          data: action.payload.data,
          isError: false,
        },
      });
    //#endregion

    //#region for debtor search data
    case GET_DEBTOR_GLOBAL_SEARCH_DATA:
      return Object.assign({}, state, getDebtorObject([], true, false), {
        isDataArchived: false,
      });
    case GET_DEBTOR_GLOBAL_SEARCH_DATA_SUCCESS:
      return Object.assign(
        {},
        state,
        getDebtorObject(
          (action.payload.data as DebtorSearchResult[]) ?? [],
          false,
          false
        )
      );
    case GET_DEBTOR_GLOBAL_SEARCH_DATA_FAIL:
      return Object.assign({}, state, getDebtorObject([], false, true));
    case TOGGLE_GLOBAL_DEBTOR_AR:
      return Object.assign({}, state, {
        debtor: <DebtorSearchResultModel>{
          isLoading: false,
          data: action.payload.data,
          isError: false,
        },
      });
    //#endregion
    //#region for case search history
    case GET_GLOBAL_SEARCH_HISTORY:
      return Object.assign({}, state, {
        history: <SearchHistoryResultModel>{
          isLoading: true,
          data: [],
          isError: false,
        },
      });

    case GET_GLOBAL_SEARCH_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        history: <SearchHistoryResultModel>{
          data: action.payload.data ?? [],
          isLoading: false,
          isError: false,
        },
      });

    case GET_GLOBAL_SEARCH_HISTORY_FAIL:
      return Object.assign({}, state, {
        history: <SearchHistoryResultModel>{
          isError: true,
          isLoading: false,
          data: [],
        },
      });
    case GLOBAL_BROWSER_BACK_NAVIGATION:
      return Object.assign({}, state, {
        backNavigation: {
          ...state.backNavigation,
          ...action.payload.data,
        },
      });
    case UPDATE_VIEWED_GLOBAL_LIST:
      return Object.assign({}, state, {
        ...action.payload.data,
      });

    //#region for Archive invoice search data
    case GET_ARCHIVE_GLOBAL_SEARCH_DATA:
      return Object.assign(
        {},
        state,
        getInvoiceObject(state.invoice.data, true, false),
        getCaseObject(state.case.data, true, false)
      );
    case GET_ARCHIVE_GLOBAL_SEARCH_DATA_SUCCESS:
      return Object.assign(
        {},
        state,
        getInvoiceObject(action.payload.data?.invoiceList ?? [], false, false),
        getCaseObject(action.payload.data?.caseList ?? [], false, false),
        {
          isDataArchived: true,
        }
      );
    case GET_ARCHIVE_GLOBAL_SEARCH_DATA_FAIL:
      return Object.assign(
        {},
        state,
        getInvoiceObject(state.invoice.data, false, false),
        getCaseObject(state.case.data, false, false),
        {
          isDataArchived: false,
        }
      );
    //#endregion
    //#region for Archive Case search data
    case GET_ARCHIVE_GLOBAL_CASE_DETAILS:
      return Object.assign({}, state, {
        archivedDetails: {
          data: null,
          isLoading: true,
        },
      });
    case GET_ARCHIVE_GLOBAL_CASE_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        archivedDetails: {
          data: action.payload.data,
          isLoading: false,
        },
      });
    case GET_ARCHIVE_GLOBAL_CASE_DETAILS_FAIL:
      return Object.assign({}, state, {
        archivedDetails: {
          data: null,
          isLoading: false,
        },
      });
    //#endregion
    //#region for Company Config data
    case GET_COMPANY_CONFIG:
      return Object.assign({}, state, {
        companyConfig: {
          ...state.companyConfig,
          isLoading: true,
        },
      });
    case GET_COMPANY_CONFIG_SUCCESS:
      return Object.assign({}, state, {
        companyConfig: {
          data: action.payload.data,
          isLoading: false,
        },
      });
    case GET_COMPANY_CONFIG_FAIL:
      return Object.assign({}, state, {
        companyConfig: {
          data: [],
          isLoading: false,
        },
      });
    //#endregion
    default:
      return state;
  }
};
